<template>
  <v-row class="ma-2">
    <CustomButton v-if="!hidePreviousButton" :disabled="disablePreviousButton" :level="$enums.ButtonLevels.Secondary" :text="previousLabel ?? 'Previous'" class="mr-2" @click="$emit('previous')" />
    <CustomButton v-if="!hideNextButton" :disabled="disableNextButton" class="ml-auto" :level="$enums.ButtonLevels.Primary" :text="nextLabel ?? 'Continue'" @click="$emit('next')"/>
  </v-row>
</template>

<script lang="ts">
import { Vue, Options, prop } from 'vue-class-component'
import CustomButton from '@/components/UIElements/CustomButton.vue'

class Props {
  hidePreviousButton?: boolean = prop({
    required: false,
  });
  hideNextButton?: boolean = prop({
    required: false,
  });
  disablePreviousButton?: boolean = prop({
    required: false,
  });
  disableNextButton?: boolean = prop({
    required: false,
  });
  previousLabel?: string = prop({
    required: false,
  });
  nextLabel?: string = prop({
    required: false,
  });
}


@Options({
  components: {
    CustomButton
  },
})
export default class MPFDefault extends Vue.with(Props) {}
</script>
